var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17.455,
    viewBox: "0 0 16 17.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_1_",
    "data-name": "flag (1)",
    transform: "translate(-1 0)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M16.451,5.255c-.137.209-3.626,4.914-7.854,3.631-2.631-.8-4.444.013-6.847.524V1.62c2.926-.137,5.459-.131,7.6,1.368a9.564,9.564,0,0,0,6.564,1.521.489.489,0,0,1,.537.746Z",
    transform: "translate(-0.205 -0.427)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M1.545,0A.546.546,0,0,0,1,.545V16.909a.545.545,0,1,0,1.091,0V9.671A6.764,6.764,0,0,1,8.3,8.837c4.7,1.426,8.455-4.116,8.612-4.352a.545.545,0,0,0-.6-.828A9.3,9.3,0,0,1,9.13,2.281,10.234,10.234,0,0,0,2.091.8V.545A.546.546,0,0,0,1.545,0Zm6.96,3.174a10.175,10.175,0,0,0,6.661,1.757c-1.257,1.426-3.783,3.7-6.554,2.862a8.021,8.021,0,0,0-6.522.567V1.9A9.349,9.349,0,0,1,8.506,3.174Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.5c7cabd7f07fd6d88b3b529b45a40048.svg";
export { ForwardRef as ReactComponent };